import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-green-900" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-oswald text-3xl sm:text-4xl font-bold text-white mb-4">
            Contact Our Expert Team
          </h2>
          <div className="h-1 w-24 bg-amber-500 mx-auto mb-6" />
          <p className="font-inter text-white/80 max-w-2xl mx-auto">
            Ready to enhance your outdoor space? Get in touch with our team of certified professionals.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Lawn Care Contact */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center" data-testid="contact-lawn-care">
            <div className="bg-amber-500 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone className="text-white" size={24} />
            </div>
            <h3 className="font-oswald text-xl font-semibold text-white mb-2">
              Lawn Care
            </h3>
            <p className="font-inter text-white/70 text-sm mb-3">Chris</p>
            <a
              href="tel:0421441364"
              className="font-oswald text-lg text-amber-400 hover:text-amber-300 transition-colors"
              data-testid="phone-lawn-care"
            >
              0421 441 364
            </a>
          </div>

          {/* Exterior Cleaning Contact */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center" data-testid="contact-exterior">
            <div className="bg-amber-500 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone className="text-white" size={24} />
            </div>
            <h3 className="font-oswald text-xl font-semibold text-white mb-2">
              Exterior Cleaning
            </h3>
            <p className="font-inter text-white/70 text-sm mb-3">Ryan</p>
            <a
              href="tel:0401226517"
              className="font-oswald text-lg text-amber-400 hover:text-amber-300 transition-colors"
              data-testid="phone-exterior"
            >
              0401 226 517
            </a>
          </div>

          {/* Email */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center" data-testid="contact-email">
            <div className="bg-amber-500 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="text-white" size={24} />
            </div>
            <h3 className="font-oswald text-xl font-semibold text-white mb-2">
              Email Us
            </h3>
            <p className="font-inter text-white/70 text-sm mb-3">General Enquiries</p>
            <a
              href="mailto:empirelawncareandmaintenance@gmail.com"
              className="font-inter text-sm text-amber-400 hover:text-amber-300 transition-colors break-all"
              data-testid="email-link"
            >
              empirelawncareandmaintenance@gmail.com
            </a>
          </div>

          {/* Location */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center" data-testid="contact-location">
            <div className="bg-amber-500 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin className="text-white" size={24} />
            </div>
            <h3 className="font-oswald text-xl font-semibold text-white mb-2">
              Service Area
            </h3>
            <p className="font-inter text-white/70 text-sm mb-3">Coffs Harbour Region</p>
            <p className="font-inter text-sm text-amber-400">
              New South Wales, Australia
            </p>
          </div>
        </div>

        {/* Business Hours */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-6 py-3">
            <Clock className="text-amber-500 mr-3" size={20} />
            <span className="font-inter text-white text-sm">
              Available Monday - Friday | 7:30am - 3:30pm
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
